
import { getDetailStation, updateStationConfiguration } from "@/service/station.service";
import { defineComponent, isProxy, PropType, ref } from "@vue/runtime-core";
import { ElForm } from "element-plus";
import { AppError } from "@/types/app.type";
import { Station } from "@/types/station.type";
import { MassiveCapture } from "@/types/massiveCapture.type";
import { getDataSamplingPointByStationCode } from "@/service/samplingpoint.service";
import { Filter } from "@/types/filter.type";
import { getTmoa } from "@/service/tmoa.service";
import { SamplingPoint } from "@/types/samplingpoint.type";
import { Tmoa } from "@/types/tmoa.type";

export default defineComponent({
  components: {},
  props: {
    station: {
      type: String,
      required: false,
    },
    stationData: {
      type: Object as PropType<Station>,
    },
  },
  setup() {
    return {
      entity: ref({} as undefined | Station),
      apikeyType: ref("password"),
      rules: {},
    };
  },
  data() {
    return {
      selectedCheck: "",
      path1: "" as string,
      types: [
        {
          value: "tmoa",
          label: "Tipología de agua",
        },
        {
          value: "timetable",
          label: "Horario",
        },
      ],
      options: [
        { label: "0", value: "0" },
        { label: "90", value: "90" },
        { label: "180", value: "180" },
        { label: "270", value: "270" },
      ],
      tmoasOptions: [] as Array<{ label: string | undefined; value: number | undefined }>,
      samplingPoint: {} as SamplingPoint | undefined,
      tmoaActiveName: "" as string,
    };
  },
  async mounted() {
    if (isProxy(this.stationData)) {
      // - set from property
      this.entity = Object.assign({}, this.stationData);
      // this.entity = this.stationData;
    } else if (this.station) {
      // - set from service
      this.entity = await getDetailStation(this.station);
    }
    // Inicializar valores si no están configurados
    if (this.entity) {
      this.entity.day = this.entity.day || 400;
      this.entity.night = this.entity.night || 50;
    }

    if (this.entity?.massiveCapture === null) {
      this.entity.massiveCapture = {} as MassiveCapture;
      this.entity.massiveCapture.active = false;
      this.entity.massiveCapture.fromDateTime = undefined;
      this.entity.massiveCapture.toDateTime = undefined;
      this.entity.massiveCapture.path = undefined;
      this.entity.massiveCapture.type = "timetable";
      this.entity.massiveCapture.typeTMOA = [] as number[];
      this.entity.massiveCapture.tmoaActive = undefined;
    }

    await this.getSamplingPoint();
    await this.getInfoSamplingPoint();
  },
  methods: {
    async getInfoSamplingPoint() {
      console.log(this.entity?.massiveCapture?.type);
      if (this.entity?.massiveCapture?.type && this.entity?.massiveCapture.type === "tmoa") {
        await this.changeOptions();
      }
    },
    async doSave(): Promise<Station | undefined> {
      if (!this.entity) return;

      const valid = await (this.$refs["form"] as InstanceType<typeof ElForm>).validate();
      if (!valid) throw new Error(AppError.FORM_VALIDATION);

      updateStationConfiguration(this.entity);
      return this.entity;
    },

    toogleApikeyType(): void {
      this.apikeyType = this.apikeyType === "password" ? "text" : "password";
    },

    async updatedPathPart1() {
      if (
        this.entity?.massiveCapture &&
        this.entity.station &&
        this.entity?.massiveCapture.active &&
        this.entity.massiveCapture.path == undefined
      ) {
        this.path1 = `${this.samplingPoint?.code ? this.samplingPoint.code : this.entity.station}`;
        this.entity.massiveCapture.path = `/${this.path1}/`;
      }
    },

    updatedPath() {
      if (
        this.entity?.massiveCapture &&
        this.entity.station &&
        this.entity?.massiveCapture.active
      ) {
        this.entity.massiveCapture.path = `/${this.path1}/${
          this.entity.massiveCapture.camera ?? ""
        }/`;
      }
    },

    async changeOptions() {
      if (
        this.entity?.massiveCapture?.type &&
        this.entity.massiveCapture.type === "tmoa" &&
        this.tmoasOptions.length === 0 &&
        this.samplingPoint?.id
      ) {
        const filter: Filter = {
          fields: {
            "tmoa.samplingPointId": {
              operator: "equal",
              value: this.samplingPoint.id,
            },
          },
        };

        //- Obtener tmoas
        const tmoas = await getTmoa(filter);

        //- Generar las opciones en tmoas
        this.tmoasOptions = tmoas.map((_: Tmoa) => ({
          value: _.value,
          label: _.name,
        }));

        //- Cambia el valor númerico por el nombre en Estado
        const tmoaActiveValue = this.entity.massiveCapture?.tmoaActive;
        if (tmoaActiveValue) {
          this.tmoaActiveName = tmoas.find((_) => _.value === tmoaActiveValue)?.name ?? "";
        }

        this.entity.massiveCapture.typeTMOA = this.entity.massiveCapture.typeTMOA?.map(Number);

        //- Cambia el valor númerico por el nombre en eel array de Tipologías de agua
        /* if (this.entity.massiveCapture.typeTMOA && this.entity.massiveCapture.typeTMOA.length > 0) {
          const selectedTmoas = this.entity.massiveCapture.typeTMOA as string[];
          this.entity.massiveCapture.typeTMOA = [];
          this.entity.massiveCapture.typeTMOA.push(
            ...selectedTmoas.map(
              (type: string) => tmoas.find((_) => `${_.value}` === type)?.name ?? ""
            )
          );
        } */
      }
    },

    async getSamplingPoint() {
      if (!this.samplingPoint?.id && this.entity?.station) {
        this.samplingPoint = await getDataSamplingPointByStationCode(this.entity.station);
      }
    },
  },
});
